{
  "All learning items": "Alla lärobjekt",
  "Learning": "Lärobjekt",
  "Event": "Event",
  "Events": "Events",
  "Filter by": "Filtrera på",
  "All types": "Alla",
  "All durations": "Alla längder",
  "< 15 min": "< 15 minuter",
  "15-60 min": "15-60 minuter",
  "1-4 hrs": "1-4 timmar",
  "4-8 hrs": "4-8 timmar",
  "1-7 days": "1-7 dagar",
  "7-30 days": "7-30 dagar",
  "> 1 month": "> 1 månad",
  "Sort by": "Sortera på",
  "Featured": "Tips",
  "Featured_plural": "Tips",
  "Categories": "Kategorier",
  "Subjects": "Ämnen",
  "All": "Alla",
  "Providers": "Partners",
  "no-filter-match": "Hittade inga resultat. <0>Rensa filtreringen.</0>",
  "no-filter-match_events": "Hittade inga händelser. <0>Rensa filtreringen.</0>",
  "no-learning-material": "Det finns inga lärobjekt här än.",
  "no-learning-material_collection": "Det finns inga lärobjekt i det här galleriet än.",
  "no-learning-material_subject": "Det finns inga lärobjekt här än.",
  "no-learning-material_category": "Det finns inga lärobjekt här än.",
  "Pending approval": "Väntar på godkännande",
  "Ongoing": "Pågående",
  "Completed": "Klar",
  "You're done, nice work!": "Du är klar, bra jobbat!",
  "No progress on learning path yet": "Lärandevägen har inte påbörjats ännu",
  "external": "Campus online",
  "user-generated": "Manuellt tillagd",
  "No filter": "Inga filter",
  "type-filter": "Typ: {{type}}",
  "Title: A-Z": "Titel: A-Ö",
  "Title: Z-A": "Titel: Ö-A",
  "Date: Newest first": "Datum: Stigande",
  "Date: Oldest first": "Datum: Fallande",
  "Featured first": "Utvalda först",
  "Event title": "Titel event",
  "Filter": "Filter",
  "Filter by title": "Filtrera på titel",
  "Choose...": "Välj...",
  "Provider": "Partner",
  "Sort": "Sortera",
  "Type": "Lärtyp",
  "remove-course-prompt": "Om du avanmäler dig från kursen \"{{name}}\" så kommer din progress i kursen tas bort permanent.<0 />Är du säker på att du vill ta bort kursen?",
  "All Learning": "All Learning",
  "Search": "Sök",
  "Duration": "Tid",
  "Filter by Space": "Filtrera på Space",
  "Filter by Provider": "Filtrera på partner",
  "Filter by Type": "Filtrera på lärtyp",
  "Filter by Category": "Filtrera på kategori",
  "Filter by Subject": "Filtrera på ämne",
  "Filter by Duration": "Filtrera på tid",
  "Filter by Language": "Filtrera på språk",
  "Filter by Attribute": "Filtrera på attribut",
  "More filters": "Fler filter",
  "Clear all filters": "Rensa alla filter",
  "Attributes": "Attribut",
  "Sort learning material": "Sortera lärobjekt",
  "new": "ny",
  "Required": "Obligatorisk",
  "expires_in_n_days_singular": "{{count}} dag kvar",
  "expires_in_n_days_plural": "{{count}} dagar kvar",
  "expired": "utgången",
  "Recommended": "Rekommenderad",
  "learning-item": "1 Lärobjekt",
  "learning-item_other": "{{count}} Lärobjekt",
  "Upcoming events": "Kommande event",
  "upcoming": "Kommande",
  "new-course": "New course",
  "cancel": "Cancel",
  "create": "Create",
  "choose-space": "Choose space",
  "space": "Space",
  "title": "Title",
  "enter-title": "Enter title",
  "settings": "Settings",
  "category": "Category",
  "total-effort": "Total time",
  "level": "Level",
  "partners": "Partners",
  "user-visibility": "Visibility",
  "save": "Save",
  "HIDDEN": "Hidden",
  "VISIBLE": "Visible",
  "FEATURED": "Featured",
  "add-your-document": "Add your document",
  "teaser": "Teaser",
  "teaser-error": "Enter description max 256 characters",
  "error-on-creation": "Unable to create course. Try again.",
  "course-created": "Course created",
  "pdf-file-upload-limit": "Only .pdf (Maximum size 200 MB)",
  "uploading": "Uploading",
  "course-deleted": "Course deleted",
  "visibility": "Visibility",
  "visibility-caption": "Choose how learners see your course",
  "hidden-caption": "Learners can't find your course in Search or Explore",
  "visible-caption": "Learners can find your course in Search or Explore",
  "featured-caption": "Bring your course to the top of the Explore page",
  "level-caption": "Show what level your course is on",
  "total-effort-caption": "Estimate time needed for learners to complete the course",
  "hours": "Hours",
  "minutes": "Minutes",
  "hours-error": "Enter number of hours",
  "minutes-error": "Enter number of minutes",
  "save-confirmation-title": "Save before leaving",
  "save-warning-caption": "Your changes will disappear if you leave without saving.",
  "dont-save": "Exit without saving",
  "save-leave": "Save & Exit",
  "fix-errors": "Missing required field",
  "fix-errors-caption": "Something is missing! Go back and check the required fields. Your changes will disappear if you leave without saving.",
  "course-remove": "Course removed from My Learning",
  "course-add": "Course saved to My Learning",
  "journey-add": "Journey saved to My Learning",
  "journey-remove": "Journey removed from My Learning",
  "list": "List",
  "remove-my-learning": "Remove from My Learning",
  "save-my-learning": "Save to My Learning",
  "close": "Close",
  "start-course": "Start",
  "total-time": "Total time",
  "status": "Status",
  "nice-work": "Nice work!",
  "success-check-in-survey": "Alright! Onwards and upwards!",
  "success-check-out-survey": "Time to turn learning into action!",
  "missing-effort-modal-title": "Set your course up to succeed",
  "missing-effort-modal-subtitle": "You can easily change under settings at anytime",
  "add-video": "Add video",
  "or": "OR",
  "Delete": "Delete",
  "Permanently remove your course": "Permanently remove your course",
  "Delete course": "Delete course",
  "You will lose all progress data": "You will lose all progress data for  <0>‘{{courseTitle}}’</0>. This cannot be undone.",
  "Are you sure you want to permanently remove this course": "Are you sure you want to <0>permanently remove</0> this course?",
  "paste-url": "PASTE URL"
}
